import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Translate, translate } from 'react-i18nify';

const SpecialValues = ({ classes }) => (
  <React.Fragment>
    <div className={classes.subheader}>
      <Translate value="blockPage.specialValues.subheader" />
    </div>
    <div className={classes.specialValue}>
      %d
      <div className={classes.valueText}>
        <Translate value="blockPage.specialValues.d" />
      </div>
    </div>
    <div className={classes.specialValue}>
      %t
      <div className={classes.valueText}>
        <Translate value="blockPage.specialValues.t" />
      </div>
    </div>
    {/*<div className={classes.specialValue}>
      %tq
      <div className={classes.valueText}>
        <Translate
          value="blockPage.specialValues.tq"
        />
      </div>
    </div>
    <div className={classes.specialValue}>
      %z
      <div className={classes.valueText}>
        <Translate
          value="blockPage.specialValues.z"
        />
      </div>
    </div>*/}
  </React.Fragment>
);

const styles = {
  subheader: {
    color: '#7F7F7F',
    fontSize: '12px',
    lineHeight: '16px',
    marginBottom: '24px',
  },
  specialValue: {
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: '16px',
    fontWeight: 500,
    fontSize: '14px',
    marginBottom: '16px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  valueText: {
    flexBasis: '60%',
    fontSize: '12px',
    fontWeight: 400,
  },
};

SpecialValues.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { name: 'SpecialValues' })(SpecialValues);
